module.exports = "/static-assets/_next/static/images/img-e62ea978d9-a47594c149138b1b681f0fde6f44737d.webp";